/* unplugin-vue-components disabled */import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-select-chain.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "header-content"
};
const _hoisted_2 = {
  class: "user"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, null, -1);

const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "email"
};
const _hoisted_6 = {
  class: "setting-icons"
};
const _hoisted_7 = {
  key: 1,
  class: "chain-select-container"
};
import { getChainName, getChainNameByChainId } from '@/service/chains-config';
import { useUserStore } from '@/store/user';
import { copy, formatAddress } from '@/utils/useUniPass';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-home-page-header',

  setup(__props) {
    const userStore = useUserStore();
    const label = computed(() => getChainName(getChainNameByChainId(userStore.chainId)));
    const show = ref(false);
    const cover = ref(null);

    const toggle = async () => {
      var _cover$value;

      show.value = !show.value;
      await nextTick();
      const page = document.querySelector('.page');

      if (cover !== null && cover !== void 0 && (_cover$value = cover.value) !== null && _cover$value !== void 0 && _cover$value.style) {
        cover.value.style.height = page.offsetHeight - 90 + 'px';
      }

      init();
    };

    const init = () => {
      document.body.style.overflow = show.value ? 'hidden' : '';
    };

    init();
    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      const _component_router_link = _resolveComponent("router-link");

      const _component_up_select_chain = __unplugin_components_1;

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['up-home-page-header', show.value ? 'up-home-page-header-bg' : ''])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userStore).accountInfo.email), 1), _createElementVNode("div", {
        class: "address",
        onClick: _cache[0] || (_cache[0] = $event => _unref(copy)(_unref(userStore).accountInfo.address))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(formatAddress)(_unref(userStore).accountInfo.address)), 1), _createVNode(_component_up_icon, {
        name: "copy"
      })])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_up_icon, {
        class: "setting",
        name: _unref(label),
        onClick: toggle
      }, null, 8, ["name"]), _createVNode(_component_router_link, {
        class: "setting",
        to: "/setting"
      }, {
        default: _withCtx(() => [_createVNode(_component_up_icon, {
          name: "setting"
        })]),
        _: 1
      })])]), show.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "cover",
        ref: cover,
        class: "cover"
      }, null, 512)) : _createCommentVNode("", true), show.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_up_select_chain, {
        class: "chain-options",
        onChange: toggle
      })])) : _createCommentVNode("", true)], 2);
    };
  }

});